// extracted by mini-css-extract-plugin
module.exports = {"catalogPage":"CatalogPage_catalogPage__8W4Lu","pageHeader":"CatalogPage_pageHeader__1qRMP"};